import { create } from 'zustand'; 
import { persist } from 'zustand/middleware';
import { getUserInfo } from '@/api/user';

interface UserState {
  token: string | null;
  username: string | null;
  isLoginModalOpen: boolean;
  login: (token: string) => void;
  logout: () => void;
  checkTokenExpiry: () => boolean;
  clearAuth: () => void; 
  isAuthenticated: boolean; 
  _hasHydrated: boolean;
  _setHydrated: (hydrated: boolean) => void;
  syncAuthState: () => void;
}

// 创建 store
export const useUserStore = create<UserState>()(
  persist(
    (set, get) => ({
      token: null,
      username: null,
      isLoginModalOpen: false,
      isAuthenticated: false,

      _hasHydrated: false,
      _setHydrated: (hydrated: boolean) => set({ _hasHydrated: hydrated }),

      login: async (token: string) => {
        set({ token, isLoginModalOpen: false, isAuthenticated: true });
        // 登录成功后获取用户信息
        try {
          const response = await getUserInfo();
          if (response.data?.username) {
            set({ username: response.data.username });
            // zustand persist 会自动保存到 localStorage
          }
        } catch (error) {
          console.error('获取用户信息失败:', error);
        }
      },
      logout: () => {
        set({ token: null, isLoginModalOpen: true, isAuthenticated: false });
      },
      checkTokenExpiry: () => {
        const { token } = get();
        if (!token) return false;
        
        try {
          return token.length > 0;
        } catch (error) {
          console.error('Token检查失败:', error);
          return false;
        }
      },
      clearAuth: () => {
        set({ token: null, username: null, isAuthenticated: false });
      },
      syncAuthState: () => {
        const { token } = get();
        set({ isAuthenticated: !!token });
      },
    }),
    {
      name: 'userinfo',
      partialize: (state: UserState) => ({ token: state.token, username: state.username }),
      onRehydrateStorage: () => (state) => {
        if (state?.token) {
          state.isAuthenticated = true;
        }
        state?._setHydrated?.(true);
      },
    }
  )
);
